<template>
    <div id="emPowerAsMember">
        <div class="mybreadcrumb">
            <i class="iconfont icon-shouquan-tianchong" style="margin-right:10px;color:#999"></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>授权管理</el-breadcrumb-item>
                <el-breadcrumb-item>按成员</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="display:flex;align-items:center;justify-content:space-between;margin-top:15px">
            <p class="asmember-tittle">所有成员({{total}})</p>
            <el-input placeholder="手机号/姓名/部门" 
                    v-model.trim="queryParams.searchName"
                    maxlength="30" 
                    size="small"
                    style="width:240px;margin-right:30px"
                    @keyup.enter.native="conditionsearchClick">
                        <i slot="suffix" 
                        class="el-input__icon el-icon-search" 
                        style="cursor:pointer" 
                        @click="conditionsearchClick"></i>
            </el-input>
        </div>
        
        <div class="table-wraper">
            <el-table
            v-loading="loading"
            :data="tableData"
            border
            :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
            style="width: 100%"
            :cell-class-name="tabCellClassName"
            @sort-change="hanleSort">
            <el-table-column
                    label="序号"
                    type="index"
                    width="60"
                    align="center"
                    >
                <template slot-scope="scope">
                    <span>{{(queryParams.pageIndex-1) * queryParams.pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            width="110px"
            show-overflow-tooltip>
            </el-table-column>
            <el-table-column
            prop="userName"
            label="姓名/企业昵称"
            show-overflow-tooltip
            align="center"
            width="120px">
            </el-table-column>
            <el-table-column
            prop="department"
            label="部门"
            :show-overflow-tooltip="!isShowTotalDepartment"
            align="center">
                <template slot="header" >
                    <div style="display:flex;">
                        <span style="flex:1">部门</span>
                        <div style="float:right;display:flex;align-items:center" class="switch-department">
                            <el-switch
                                :disabled="isSwitchDis"
                                v-model="isShowTotalDepartment"
                                @change="handleSwitchChange">
                            </el-switch>
                            <el-tooltip class="item" effect="dark" content="开关开启可显示全部部门" placement="top">
                                <span class="el-icon-warning-outline" style="margin-left:5px;color:#0069e0;font-size:14px"></span>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
            sortable="custom"
            prop="addedAt"
            label="加入时间"
            show-overflow-tooltip
            align="center">
            </el-table-column>
            
            <el-table-column
            prop="hasGrantCount"
            label="授权数量"
            sortable="custom"
            width="110"
            align="center">
            </el-table-column>
            <el-table-column
            align="center"
            label="操作"
            width="140">
            <template slot-scope="scope">
                <div @click="managepower(scope.row)" class="manage-button">管理授权</div>
            </template>
            </el-table-column>
        </el-table>
         <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,30,50,100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :current-page="queryParams.pageIndex"
                :page-size="queryParams.pageSize"
                style="margin-top:30px">
            </el-pagination>
        </div>
        
    </div>
</template>

<script>
import {GrantSNToEnterpriseUserApi,
UpdatePageStatusRecordApi,
GetPageStatusRecordApi} from '@/js/enterPriseApi'
import {MyZhugeTrackClickManPower} from '@/js/zhugemaidian.js'
import moment from 'moment'
export default {
    name:"allProAndSer",
    data(){
        return {
                loading:false,
                total:0,
                status:"1",
                tableData: [],
                searchName:'',
                queryParams:{
                    pageSize:10,
                    pageIndex:1,
                    searchName:'',
                    orderName:0,//0为AddedAt，1为HasGrantCount
                    isOrderDesc:true,
                    enterPriseId:window.localStorage.getItem('enterPriseId')
                },
                total:0,
                isShowOverflowtip:true,
                isShowTotalDepartment:false,
                isSwitchDis:false,//开关是否禁用

            }
    },
    created(){
        if(window.localStorage.getItem('enterPriseId')){
            if(this.$route.query.pageIndex){
                this.queryParams.pageIndex=Number(this.$route.query.pageIndex)
                this.queryParams.pageSize=Number(this.$route.query.pageSize)
            }
            this.getallSnUserInfo(this.queryParams);
            this.GetPageStatusRecord()
        }
    },
    methods:{
        GetPageStatusRecord(){//获取部门全称的开关状态
            GetPageStatusRecordApi({//自定义的按钮标识
                pageStatusCode:'yhtqt-acy-bmxs'
            })
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    if(res.data.data){
                        if(res.data.data.dataValue==='1'){
                            this.isShowTotalDepartment=true
                        }else if(res.data.dataValue==='0'){
                            this.isShowTotalDepartment=false
                        }
                    }
                }else{
                    if(res.data.error_code!=404){//特殊处理，404就是默认第一次请求
                        this.$message.error(res.data.error_msg)
                    }
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    this.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    this.$message.error(err.data)
                }
            })
        },
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        handleSwitchChange(val){//开关切换
            // if(val){//开关开启不显示省略号，显示全部部门
            //     this.isShowOverflowtip=false
            // }else{
            //     this.isShowOverflowtip=true
            // }
            this.UpdatePageStatusRecord(val)
        },
        UpdatePageStatusRecord(val){//自定义标记状态，开关开着，传值为‘1’，关闭，传值为‘0’
            this.isSwitchDis=true
            UpdatePageStatusRecordApi({
                pageStatusCode: "yhtqt-acy-bmxs",
                pageStatusName: "一号通前台按成员分配授权部门显示",
                dataValue: val?'1':'0'
            })
            .then(res=>{
                this.isSwitchDis=false
                if(res.status===200 && res.data.error_code===0){
                    if(res.data){//修改成功的状态
                        if(val){
                            this.isShowTotalDepartment=true
                        }else{
                            this.isShowTotalDepartment=false
                        }
                    }
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                this.isSwitchDis=false
                this.isShowTotalDepartment=!val
                this.$message.error('按钮状态更新失败')
                if(err.data && err.data.errorMessages){
                    this.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    this.$message.error(err.data)
                }
            })
        },
        hanleSort(column,prop,order){
            console.log(column,prop,order)
            if(column.prop=='addedAt'){
                this.queryParams.orderName=0;
                if(column.order=='descending'){
                    this.queryParams.isOrderDesc=true;
                }else{
                    this.queryParams.isOrderDesc=false;
                }
            }else if(column.prop=='hasGrantCount'){
                this.queryParams.orderName=1;
                if(column.order=='descending'){
                    this.queryParams.isOrderDesc=true;
                }else{
                    this.queryParams.isOrderDesc=false;
                }
            }
            this.getallSnUserInfo(this.queryParams)
        },
        handleSizeChange(val){//每页多少改变触发
            let that=this;
            this.queryParams.pageSize=val;
            this.getallSnUserInfo({
                pageSize:val,
                pageIndex:this.queryParams.pageIndex,
                searchName:that.queryParams.searchName,
                orderName:that.queryParams.orderName,
                isOrderDesc:that.queryParams.isOrderDesc,
                enterPriseId:window.localStorage.getItem('enterPriseId')
            })
        },
        handleCurrentChange(currentpage){//当前页数切换
            let that=this
            this.queryParams.pageIndex=currentpage
            this.getallSnUserInfo({
                pageSize:that.queryParams.pageSize,
                pageIndex:currentpage,
                searchName:that.queryParams.searchName,
                orderName:that.queryParams.orderName,
                isOrderDesc:that.queryParams.isOrderDesc,
                enterPriseId:window.localStorage.getItem('enterPriseId')
            })
        },
        conditionsearchClick(){
            let that=this;
            that.queryParams.pageSize=10;
            that.queryParams.pageIndex=1;
            that.queryParams.orderName=0//0为AddedAt，1为HasGrantCount
            that.queryParams.isOrderDesc=true

            that.getallSnUserInfo(this.queryParams)

        },
        managepower(row){
            MyZhugeTrackClickManPower({
                "管理方式":'按成员'
            })
            let queryinfo={
               userId:btoa(row.userId),
               pageSize:this.queryParams.pageSize,
               pageIndex:this.queryParams.pageIndex
            }
            console.log(queryinfo);
            this.$router.push({
                path:`/manageAsMember`,
                query:queryinfo
            })
        },
        getallSnUserInfo(params){//获取所有成员信息
            let that=this;
            this.loading=true;
            GrantSNToEnterpriseUserApi(params)
            .then(res=>{
                console.log(res);
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data
                    that.total=0;
                    that.tableData=[];
                    that.total=data.totalItems;
                    data.list.forEach((item)=>{
                        let obj={
                            userId:item.userId,
                            userName:item.userName,
                            phone:item.phone,
                            department:item.department,
                            inviteStatus:item.inviteStatus,
                            hasGrantCount:item.hasGrantCount,
                            addedAt:item.addedAt?moment(item.addedAt).format('YYYY-MM-DD HH:mm:ss'):''
                        }
                        that.tableData.push(obj)
                    })
                    this.loading=false;
                }else{
                    that.$message.error(res.data.error_msg)
                    this.loading=false;
                }
            }) 
            .catch(err=>{
                this.loading=false;
                console.log(err);
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }
            })
        }
    }
     
}
</script>

<style lang="scss" scoped>
    #emPowerAsMember{
        background: #fff;
        min-height: 100%;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            display: flex;
            align-items: center;
            padding: 13px 0 13px 20px;
            border-bottom: 1px solid #EAEAEA;
        }
        .asmember-tittle{
            text-align: left;
            padding: 20px 0 15px 30px;
            font-family: FZLTZHK--GBK1-0;
            font-size: 14px;
            color: #333333;
            font-weight:600
        }
        .table-wraper{
            padding: 8px 30px 30px 30px ;
            .switch-department{
                /deep/ .el-switch__core{
                    width: 30px !important;
                    height: 15px !important;
                    &:after{
                        width: 11px;
                        height: 11px;
                    }
                }
                /deep/ .el-switch.is-checked .el-switch__core::after{
                    margin-left: -14px;
                }
            }
        }
        .table-status{
            span{
                margin-left: 8px;
            }
        }
        .bgcorange::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #FE833D;
            }
        .bgcgreen::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #1DCB96;
        }
        .manage-button{
            width: 70px;
            height: 26px;
            line-height: 25px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #0069E0;
            font-weight: 400;
            background: #F0F6FD;
            border: 1px solid rgba(0,105,224,0.45);
            border-radius: 2px;
            margin: 0 auto;
            cursor: pointer;
        }
        /deep/ .el-table .cellstyle{
            padding: 8px 0 !important;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #181818;
            font-weight: 400;
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/EmPowerManage/EmPowerAsMember.vue